import { ChatMessages } from 'models/ChatMessages.jsx';
import { Request } from 'components/Request.jsx';
import { ChatRoom } from 'models/ChatRoom.jsx';
import { BrowserNotification } from 'components/BrowserNotification.jsx';
import { ChatMessageNotification } from 'models/ChatMessage.jsx';
import { MatchSounds } from 'components/MatchSounds.jsx';
import { Dashboard } from 'components/Dashboard.jsx';

import { JqueryClassFaker } from 'components/JqueryClassFaker.jsx';
import { Settings } from './Settings';

import store from 'react/redux/store/store';
import { CacheableDataObject } from "../models/CacheableDataObject";
import { checkPrivateChatDisplayOrder } from "../react/redux/actions/privateChat";
import StateHelpers from "../react/redux/store/StateHelpers";


export default class PrivateChatBox extends CacheableDataObject {
	beforeConstruct() {
		this.hasLoadingError = false;
		this.player = null;
		this.privateChatMessageHolder = null;
		this.chatMessageHolder = null;
		this.chatMessages = ChatMessages.create();
		this.chatMessages.hasNewMessagesCallback = this.hasNewMessagesCallback;
		this.chatMessages.privateChatBox = this;
		this.isBlocked = false;

		this.focused = false; // Controlled by the react component that is currently rendering an active chat

		this.close = this.close.bind(this);
	}

	hasNewMessagesCallback(lastMessage) {
		store.dispatch(checkPrivateChatDisplayOrder());
		if(lastMessage.player.isMe()) {
			return;
		}
		if(this.isActive()) {
			Request.apiv1('chat/direct_messages', { other_player_id: this.player.id, read_all: true });
		}
		if(!lastMessage.notification) {
			return;
		}
		let chatUpdateMessage = BrowserNotification.showNotification(lastMessage.notification.title, lastMessage.notification);
		if(this.isActive()) {
			chatUpdateMessage = null;
		}
		if(Settings.isChecked('direct_message_notification_sounds_general')) {
			MatchSounds.playPrivateMessageSoundEffect();
		}
		if(chatUpdateMessage && Settings.isChecked('show_direct_message_notifications_in_chat')) {
			const chatNotification = ChatMessageNotification.create();

			chatNotification.player = lastMessage.player;
			chatNotification.type = ChatMessageNotification.types.DIRECT_MESSAGE;
			chatNotification.summary = lastMessage.message;

			ChatRoom.addMessageToActiveChatRoom(chatNotification);
		}

	}

	setChatMessageHolder(chatMessageHolder) {
		this.chatMessageHolder = chatMessageHolder;
	}

	isOpen() {
		return this.chatMessageHolder.isOpen(this);
	}

	isActive() {
		if(Dashboard.isCompact()) {
			return false;
		}
		return this.isOpen() && this.focused && StateHelpers.windowHasVisibility();
	}


	setPlayer(player) {
		this.player = player;
		return this;
	}

	changed() {
		// if(this.privateChatComponentReference.current)
		// {
		// }
		this.privateChatMessageHolder.updateDisplay();
	}


	setActive() {
		this.chatMessageHolder.setChatAsOpen(this);
	}

	toggle(set) {
		if(set === true) {
			if(!this.chatMessageHolder.isOpen(this)) {
				this.chatMessageHolder.setChatAsOpen(this);
			}
		}
		else if(set === false) {
			this.chatMessageHolder.setChatAsClosed(this);
		}
		else {
			set = this.chatMessageHolder.toggleChat(this);
		}
		this.changed();
		if(set) {
			this.chatMessages.getInitialChatMessages()
				.then(() => {
					this.changed();
				});
		}
		return set;
	}

	load(loadCallback) {
		console.error('laod called?');
		this.isLoading = true;

		return this.chatMessages.loadPreviousMessages().then(() => {
			this.isLoading = false;
		}, () => {
			this.isLoading = false;
		});
	}


	close() {
		this.privateChatMessageHolder.removeChat(this);
		this.privateChatMessageHolder.setChatAsClosed();
		// this.privateChatMessageHolder.changeChatRight();
		Request.apiv1('chat/direct_message_close', { other_player_id: this.player.id });
	}

	getClasses() {
		const classes = new JqueryClassFaker();
		if(this.chatMessages.hasUnreadMessages()) {
			classes.add('has_new_messages');
		}
		if(this.loadingPreviousMessages) {
			classes.add('loading pending');
		}
		if(this.chatMessages.hasLoadingError) {
			classes.add('loading_error');
		}
		if(this.isOpen()) {
			classes.add('opened');
		}
		return classes;
	}

}